import type { TicketOutcome } from "../interfaces/api";

const supportedStatuses = new Set<TicketOutcome["status"]>([
  "created",
  "partiallyCreated",
  "retryableFailure",
  "unknown",
]);

export const readTicketOutcome = (data: any): TicketOutcome | null => {
  const outcome = data?.ticketOutcome;
  if (
    !outcome ||
    typeof outcome !== "object" ||
    !supportedStatuses.has(outcome.status)
  ) {
    return null;
  }

  return {
    status: outcome.status,
    ticketNumber:
      typeof outcome.ticketNumber === "string" && outcome.ticketNumber.trim()
        ? outcome.ticketNumber.trim()
        : undefined,
  };
};

export const isConfirmedTicketOutcome = (
  outcome: TicketOutcome | null
): outcome is TicketOutcome & { ticketNumber: string } =>
  Boolean(
    outcome?.ticketNumber &&
      (outcome.status === "created" ||
        outcome.status === "partiallyCreated")
  );

// Generated by Copilot
// updated on: 2026-10-16 | [Auto Generated] | Added structured ticket outcome parsing helpers | Time Taken 1 min
